import { api } from "../../lib/api";

export function PortalProgress({ photos }) {
  if (!photos || photos.length === 0) return null;
  return (
    <div className="de-card p-6" data-testid="portal-progress">
      <div className="label-eyebrow mb-4">Build progress photos</div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {photos.map(p => (
          <figure key={p.id} data-testid={`portal-progress-${p.id}`} className="border border-[#E5E7EB] bg-white overflow-hidden">
            <img src={`${api.defaults.baseURL}/portal/photo/${p.id}`} alt={p.caption || "Build progress"} className="w-full h-40 object-cover" loading="lazy" />
            {p.caption && <figcaption className="p-2 text-xs text-[#6B7280]">{p.caption}</figcaption>}
          </figure>
        ))}
      </div>
    </div>
  );
}
